<div class="popup">
    <mat-dialog-content class="text-center">
        <div class="container-popup">
            <div class="header">
                <span class="header-title">Make Payment {{ existingClub.fees | currency }} </span>
                <span class="header-close">
                    <button mat-icon-button (click)="onNoClick()">
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </div>

            <form >
                <div class="field">
                    <label>Select Payment Option</label>
                    <mat-tab-group [(selectedIndex)]="selectedPaymentIndex"
                        (selectedIndexChange)="onPaymentTabChange($event)">
                        <ng-container *ngFor="let payment of existingClub.payments; let i = index">
                            <mat-tab label="{{payment.paymentOption}}" *ngIf="payment.checked">
                                <div class="p-3">
                                    <div class="field mb-4" *ngIf="!isCard">
                                        <label for="gender">Pay To</label>
                                        <input id="payment" class="w-full" type="text" name="payment"
                                            value="{{payment.payTo}}" disabled />
                                    </div>
                                    <div *ngIf="isCard">
                                        <div class="field mb-4">
                                            <label for="card-element">Card Information</label>
                                            <div id="card-element" class="card-element"></div>
                                        </div>
                                        <div class="payment-status" *ngIf="paymentStatus">
                                            <mat-icon [class.success]="paymentStatus.includes('successful')"
                                                [class.error]="!paymentStatus.includes('successful')">
                                                {{ paymentStatus.includes('successful') ? 'check_circle' : 'error' }}
                                            </mat-icon>
                                            <span style="color: white;">{{ paymentStatus }}</span>
                                        </div>
                                    </div>
                                    <mat-checkbox (change)="updatePaid($event)" [checked]="paid" class="mt-3">
                                        I acknowledge receipt of the invoice and confirm that the payment has been made.
                                    </mat-checkbox>
                                </div>
                            </mat-tab>
                        </ng-container>
                    </mat-tab-group>
                </div>
            </form>
        </div>
    </mat-dialog-content>

    <div class="footer">
        <button disableRipple class="mt-3 update-btn" *ngIf="!isCard" [mat-dialog-close]="paid" [disabled]="!paid"
            (click)="onSubmit()">
            Paid
        </button>
        <button disableRipple class="mt-3 update-btn" *ngIf="isCard"
            [disabled]="!paid || !existingClub.fees || isLoading || !isCardComplete" (click)="onSubmit()">
            <span *ngIf="!isLoading">Pay {{ existingClub.fees | currency }}</span>
            <span *ngIf="isLoading">Processing...</span>
        </button>
    </div>
</div>